import { makeStyles } from '@material-ui/core/styles';
import { modalPaperStyle } from '../../../shared/components/RedesignModal/RedesignModal.styles';
import { primaryButtonStyle, secondaryButtonStyle } from '../../../shared/styles/buttons.styles';
import { redesignTheme } from '../../../theme';

const { colors, fonts, fontSize, spacing, radius, sizes, breakpoints } = redesignTheme;

export const useTestLimitModalStyles = makeStyles(() => ({
  modal: {
    ...modalPaperStyle,
    position: 'relative',
    maxWidth: sizes.contentMaxWidth,
    alignItems: 'center',
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      padding: spacing.sm,
    },
  },
  closeButton: {
    position: 'absolute',
    top: spacing.md,
    right: spacing.md,
    padding: 4,
    color: colors.primaryDark,
    '&:hover': {
      backgroundColor: colors.progressTrack,
    },
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      top: spacing.sm,
      right: spacing.sm,
    },
  },
  closeIcon: {
    width: 24,
    height: 24,
  },
  iconWrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 64,
    height: 64,
    borderRadius: radius.md,
    backgroundColor: colors.progressTrack,
    flexShrink: 0,
  },
  lockIcon: {
    width: 32,
    height: 32,
    color: colors.primary,
  },
  textBlock: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: spacing.xs,
    width: '100%',
    maxWidth: 400,
  },
  title: {
    margin: 0,
    fontFamily: fonts.gothicSemiBold,
    fontSize: fontSize.xl,
    color: colors.primary,
    lineHeight: '28px',
    textAlign: 'center',
  },
  message: {
    margin: 0,
    fontFamily: fonts.opensans,
    fontSize: fontSize.base,
    color: colors.textBody,
    lineHeight: 'normal',
    textAlign: 'center',
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.sm,
    width: '100%',
  },
  primaryButton: {
    ...primaryButtonStyle,
    lineHeight: '20px',
    letterSpacing: 0,
    textTransform: 'none',
  },
  primaryButtonIcon: {
    width: 16,
    height: 16,
  },
  secondaryButton: {
    ...secondaryButtonStyle,
    border: `1px solid ${colors.primary}`,
    color: colors.textBody,
    lineHeight: '20px',
    letterSpacing: 0,
    textTransform: 'none',
  },
}));
